import { useWorkflows, workflowSelector } from '@/store/workflows';
import { NodeShell } from '../NodeShell';
import type { NodeProps } from '@xyflow/react';

const platformIcon: Record<string, string> = {
  youtube: 'YT',
  tiktok: 'TT'
};

export function OutputNode({ data }: NodeProps & { data: { workflowId: string } }) {
  const wf = useWorkflows(workflowSelector(data.workflowId));
  if (!wf) return null;
  return (
    <NodeShell title="Output" state={wf.states.output} width={260} showRightHandle={false}>
      {wf.uploads.length === 0 ? (
        <div className="text-[11px] text-ink-500">awaiting first publish</div>
      ) : (
        <ul className="flex flex-col divide-y divide-ink-800/70">
          {wf.uploads.map((u) => (
            <li key={u.url} className="py-1.5">
              <a
                href={u.url}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2 text-xs text-ink-200 hover:text-accent-400"
              >
                <span className="inline-flex h-5 w-5 items-center justify-center rounded-md bg-ink-800 text-[9px] font-semibold text-ink-300">
                  {platformIcon[u.platform] ?? u.platform.slice(0, 2).toUpperCase()}
                </span>
                <span className="truncate flex-1">{u.title || u.url}</span>
              </a>
            </li>
          ))}
        </ul>
      )}
    </NodeShell>
  );
}
